import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"search\"><defs><style>#search .cls-1{fill:none}</style></defs><title>资源 62</title><g id=\"search_图层_2\" data-name=\"图层 2\"><g id=\"search_图层_1-2\" data-name=\"图层 1\"><path id=\"search_Rectangle_45_Copy_25\" data-name=\"Rectangle 45 Copy 25\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"search_search\"><path id=\"search_Shape\" d=\"M22.16 23a.84.84 0 0 1-.6-.25l-4.82-4.82a9 9 0 1 1 1.19-1.19l4.82 4.82a.84.84 0 0 1 0 1.19.86.86 0 0 1-.61.25zM11 3.69a7.3 7.3 0 1 0 2.85.57A7.15 7.15 0 0 0 11 3.69z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/search.svg
// module id = BzcE
// module chunks = 6